// store.ts
import { configureStore } from "@reduxjs/toolkit";
import { chatApi } from "./services/chatApi";
import { codeApi } from "./services/codeApi";
import { deployApi } from "./services/deployApi";
import { evaluateApi } from "@/services/evaluateApi";
import { githubApi } from "@/services/githubApi";
import { supabaseApi } from "@/services/supabaseApi";
import { agentApi } from "@/services/agentApi";
import designReducer from "./store/designSlice";
import appPreviewReducer from "./store/appPreviewSlice";
import logReducer from "./store/iframeLogSlice";
import themeReducer from "./store/themeSlice";
import selectedComponentsReducer from "./store/selectedComponentSlice";
import versionReducer from "./store/versionSlice"
import apiMessageReducer from "./store/apiMessageSlice";
import projectInfoReducer from "./store/projectInfoSlice";
import autoDebugReducer from "./store/autoDebugSlice";
import globalLoadingReducer from "./store/globalLoadingSlice";
import githubReducer from "@/store/githubSlice";
import authReducer from "@/store/authSlice";
import supabaseReducer from "@/store/supabaseSlice";
import chatReducer from "@/store/chatBridgeSlice";
import { screenshotApi } from "@/services/screenshotApi";
import { publishApi } from "@/services/publishApi";
import { paymentApi } from "@/services/paymentApi";
// import { loadingMiddleware } from "./store/loadingMiddleware";

const { loadingMiddleware } = require("./store/loadingMiddleware");


export const store = configureStore({
  reducer: {
    [chatApi.reducerPath]: chatApi.reducer,
    [codeApi.reducerPath]: codeApi.reducer,
    [deployApi.reducerPath]: deployApi.reducer,
    [evaluateApi.reducerPath]: evaluateApi.reducer,
    [githubApi.reducerPath]: githubApi.reducer,
    [supabaseApi.reducerPath]: supabaseApi.reducer,
    [agentApi.reducerPath]: agentApi.reducer,
    [screenshotApi.reducerPath]: screenshotApi.reducer,
    [publishApi.reducerPath]: publishApi.reducer,
    [paymentApi.reducerPath]: paymentApi.reducer,
    design: designReducer,
    appPreview: appPreviewReducer,
    iframeLogs: logReducer,
    selectedComponents: selectedComponentsReducer,
    theme: themeReducer,
    version: versionReducer,
    apiMessages: apiMessageReducer,
    projectInfo: projectInfoReducer,
    autoDebug: autoDebugReducer,
    globalLoading: globalLoadingReducer,
    github: githubReducer,
    auth: authReducer,
    supabase: supabaseReducer,
    chatBridge: chatReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      loadingMiddleware,
      chatApi.middleware,
      codeApi.middleware,
      deployApi.middleware,
      evaluateApi.middleware,
      githubApi.middleware,
      supabaseApi.middleware,
      agentApi.middleware,
      screenshotApi.middleware,
      publishApi.middleware,
      paymentApi.middleware
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
